import { render } from "./addSelection.vue?vue&type=template&id=a67bdd54"
import script from "./addSelection.vue?vue&type=script&lang=js"
export * from "./addSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__